
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Table from './Table2'
import { orderBy } from 'lodash'

class TableSortable extends Component {
  constructor ({defaultSortOrder}) {
    super()
    this.state = {
      sortOrder: defaultSortOrder
    }
  }

  render () {
    const { emptyText, columns, rows, sortBy, showSideBorders } = this.props

    // for sort order, first check state, then props as fallback
    const sortByUpdated = this.state.sortBy || sortBy

    let sortedRows = []
    // if rows array is empty, skip this logic so emptyText gets displayed
    if (rows.length) {
      // check if we are sorting strings, if true then we need to use custom sort function bc lodash sorts by unicode
      if (typeof rows[0][sortByUpdated].value === 'string') {
        sortedRows = orderBy(rows, [row => row[sortByUpdated].value.toLowerCase()], [this.state.sortOrder])
      } else {
        sortedRows = orderBy(rows, [`${sortByUpdated}.value`], [this.state.sortOrder])
      }
    }

    return (
      <Table
        emptyText={emptyText}
        columns={columns}
        rows={sortedRows}
        onHeaderClick={this.onSort.bind(this)}
        sortBy={sortByUpdated}
        sortOrder={this.state.sortOrder}
        showSideBorders={showSideBorders} />
    )
  }

  onSort (columnName) {
    const reverseOrder = this.state.sortOrder === 'desc' ? 'asc' : 'desc'
    this.setState({
      sortOrder: reverseOrder,
      sortBy: columnName
    })
  }
}

TableSortable.displayName = 'TableSortable'

TableSortable.defaultProps = {
  defaultSortOrder: 'asc',
  showSideBorders: false
}

TableSortable.propTypes = {
  columns: PropTypes.array.isRequired,
  emptyText: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  sortBy: PropTypes.string.isRequired,
  defaultSortOrder: PropTypes.oneOf(['asc', 'desc']),
  showSideBorders: PropTypes.bool
}

export default TableSortable



// WEBPACK FOOTER //
// ./ui/TableSortable.js